export default function debounce<A extends unknown[]>(
    callback: (...args: A) => void,
    wait: number,
    immediate = false,
): (...args: A) => void {
    let timeout: NodeJS.Timeout | null;
    const callable = (...args: A) => {
        const later = () => {
            timeout = null;
            if (!immediate) callback.apply(callable, args);
        };
        const callNow = immediate && !timeout;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(callable, args);
    };
    return callable;
}
